import { ActionContext } from 'vuex';

import { TBaseFilterPayload } from '@/common/types/filter';
import { getLocalState } from '@/common/utils/store';

import { TKeyCountryIndicatorTableFilter } from '../../types/keyCountryIndicator';
import { KEY_COUNTRY_INDICATOR_VES_ACTIONS_NAME, KEY_COUNTRY_INDICATOR_VES_MUTATIONS_NAME } from './name';
import { TKeyCountryIndicatorStoreState } from './types';

import { TPaginationParams } from '@/types/meta';
import links from '@/utils/links';
import request from '@/utils/request';

export async function getIndicators(context: ActionContext<TKeyCountryIndicatorStoreState, unknown>) {
  return request(
    context,
    {
      url: links.importAnalytics.keyCountryIndicator.getIndicators,
      mutate: getLocalState(KEY_COUNTRY_INDICATOR_VES_MUTATIONS_NAME.setIndicators),
      name: getLocalState(KEY_COUNTRY_INDICATOR_VES_ACTIONS_NAME.getIndicators),
    },
    {},
  );
}

export async function getCountriesList(
  context: ActionContext<TKeyCountryIndicatorStoreState, unknown>,
  payload: TBaseFilterPayload<TKeyCountryIndicatorTableFilter & TPaginationParams>,
) {
  return request(
    context,
    {
      url: links.importAnalytics.keyCountryIndicator.getCountriesList,
      name: getLocalState(KEY_COUNTRY_INDICATOR_VES_ACTIONS_NAME.getCountriesList),
      abortController: payload.abortController,
    },
    payload.params,
  );
}
